import React, {useEffect, useState} from "react";
import { DataTableFoot } from "../../../components/common/Tables/DataTableParts";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/states/root.state";
import { fetchFieldHistory } from "../../../redux/actions/spa.actions";
import { useReportTimeFormat } from "../reportTime";

interface ReportsTableProps {
    spa_guid: string;
    selected: any[];
    startDate: string;
    endDate: string;
}

const headers = [{
    label: 'Field',
    id: 'field_name',
}, {
    label: 'From',
    id: 'old_value',
}, {
    label: 'To',
    id: 'new_value',
}, {
    label: 'Reason',
    id: 'change_reason',
}, {
    label: 'Timestamp',
    id: 'changed_at',
}, {
    label: 'By',
    id: 'changed_by',
}]


const FieldHistoryTable: React.FC<ReportsTableProps> = ({selected, startDate, endDate, spa_guid}) => {
    const dispatch: AppDispatch = useDispatch();
    const {data: history, loading, meta} = useSelector((state: RootState) => state.fieldHistory);
    const formatTime = useReportTimeFormat();
    const [page, setPage] = useState(1);

    useEffect(() => {
        let params:any = {guid:spa_guid, page:page};

        if (selected.length===1) {
            params={...params, field_name:selected[0]};
        }

        dispatch(fetchFieldHistory(params));
    },[dispatch, spa_guid, selected, page]);

    
    useEffect(() => {
        if (meta) {
            setPage(meta.current_page??1);
        }
    },[meta]);

    // Dealerships show their ID, users their email
    const entity = (row: any, which: 'old_entity' | 'new_entity') => {
        const value = row?.[which];
        if (!value) return <span className="dt-na">None</span>;
        return <>{value.name} <span className="dt-sub">({row?.field_name==='dealership_id' ? value.id : value.email})</span></>;
    };

  // Rendered inside the report's result card (SpaReport), which supplies the toolbar
  return (
    <>
      <div className="dt-scroll">
        {loading ? (
          <div className="dt-state"><span className="spinner" role="progressbar" aria-label="Loading field history"/></div>
        ) : (history??[]).length>0 ? (
          <table className="dt-table">
            <thead>
              <tr>
                {headers.map((header)=>(
                  <th key={header.id} scope="col">{header.label}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {history.map((row)=>(
                <tr key={row.id}>
                  <td><span className="dt-tag">{row?.field_name}</span></td>
                  <td>{entity(row, 'old_entity')}</td>
                  <td>{entity(row, 'new_entity')}</td>
                  <td>{row?.change_reason ?? <span className="dt-na">None</span>}</td>
                  <td><span className="dt-date">{formatTime(row?.changed_at)}</span></td>
                  <td>{row?.changed_by?.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="dt-state"><div className="dt-empty-title">No Field History Found</div></div>
        )}
      </div>

      <DataTableFoot
        shown={(history??[]).length}
        total={meta?.total ?? 0}
        noun={(meta?.total ?? 0) === 1 ? 'Change' : 'Changes'}
        page={page}
        totalPages={meta?.last_page ?? 1}
        loading={loading}
        onPage={setPage}
      />
    </>
  );
};

export default FieldHistoryTable;
